import * as actionTypes from "../consts/actionTypes";

export function postPreventionsAction(param) {
    return {
        type: actionTypes.POST_PREVENTIONS,
        payload: param
    };
}